import React from 'react';
import TransitionFormFields from './TransitionFormFields';
import { transitionSchema } from '../../../lib/transition-schemas';

export default function EngagedForm({ values, onChange, errors }) {
  return <TransitionFormFields schema={transitionSchema('engaged')} values={values} onChange={onChange} errors={errors} />;
}
